<template lang="html">
  <section class="vh intro">
    <img class="w-100" src="/static/img/bkg/bkg-ajusa.webp" :alt="$t('ajusa.alt_images.sede_principal')" width="1920" height="899">
    <a href="#" v-scroll-to="'.menu-nosotros'" class="scrolldown"></a>
    <div class="col-50 flex column justify-center align-center animated fadeInLeft">
      <div class="container-text">
        <h1 class="title title-52" v-html="$t('ajusa.intro.titulo')"></h1>
        <p>{{ $t('ajusa.intro.texto') }}</p>
        <a class="btn btn-light open-pop -yellow" @click="showVideo">{{ $t('home.intro.boton') }}</a>
        <video-visualizer :id="id" :show="videoshow" @closeVideo="closeVideo"></video-visualizer>
      </div>
    </div>
  </section>
</template>

<script lang="js">
import videoVisualizer from '@/components/parts/video-visualizer'

export default {
  name: 'ajusa',
  props: [],
  components: {
    'video-visualizer': videoVisualizer
  },
  data() {
    return {
      muted: true,
      videoshow: false,
      abierto: false,
      id: 'vjFYe_seVTk'
    }
  },
  methods: {
    showVideo: function () {
      this.videoshow = true;
      this.id = 'vjFYe_seVTk';
    },
    closeVideo: function () {
      this.videoshow = false;
      this.id = '';
    }
  },
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view-parts/intros/ajusa.vue